import React, { forwardRef, RefObject } from 'react';
import classes from '../../EnterCredential.module.scss';
import { Stack } from 'new/elements/Stack';
import { TextField } from 'new/elements/TextField';
import { Search } from '@mui/icons-material';

interface SearchBarProps {
  onSearchChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> &
    React.FormEventHandler<HTMLLabelElement>;
}

export const SearchBar = forwardRef((props: SearchBarProps, ref: RefObject<HTMLDivElement>) => {
  return (
    <div ref={ref} className={classes.searchBarContainer}>
      <Stack width="50%" margin="auto">
        <TextField
          startAdornment={<Search />}
          onChange={props.onSearchChange}
          fullWidth
          inputProps={{ 'data-testid': 'credential-search-input' }}
        />
      </Stack>
    </div>
  );
});
